import { post } from "helpers/api_helper";
import { getUserToken } from "helpers/authHelper";
import { encryptDataToArray } from "helpers/EncDec";
import { getDeviceInfo } from "helpers/utils";

export async function FetchAllOrgSPOCs(reqBody) {
  reqBody = encryptDataToArray(reqBody);

  return await post(
    "/admin/organization-spoc/list",
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
      },
    }
  );
}

export async function CreateNewOrgSPOC(reqBody) {
  let device_info = await getDeviceInfo(navigator);
  reqBody = {
    ...(reqBody || {}),
    device_info: device_info,
  };

  reqBody = encryptDataToArray(reqBody);

  return await post(
    "/admin/organization-spoc/create",
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
      },
    }
  );
}

export async function UpdateOrgSPOCDetails(spocId, reqBody) {
  let device_info = await getDeviceInfo(navigator);
  reqBody = {
    ...(reqBody || {}),
    device_info: device_info,
  };

  reqBody = encryptDataToArray(reqBody);

  return await post(
    `/admin/organization-spoc/update/${spocId}`,
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
      },
    }
  );
}

export async function DeleteOrgSPOC(spocId) {
  let device_info = await getDeviceInfo(navigator);
  let reqBody = {
    device_info: device_info,
  };

  reqBody = encryptDataToArray(reqBody);

  return await post(
    `/admin/organization-spoc/delete/${spocId}`,
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
      },
    }
  );
}
